import { RENTAL_STATUS, CONDITION, LEASE_STATUS, APPROVAL_STATUS } from "@/lib/format";

const MAPS = {
  rental: RENTAL_STATUS,
  condition: CONDITION,
  lease: LEASE_STATUS,
  approval: APPROVAL_STATUS,
};

export default function StatusBadge({ kind = "rental", value, testid }) {
  const map = MAPS[kind] || {};
  const s = map[value] || { label: value || "-", bg: "#f1f5f9", text: "#475569", border: "#cbd5e1" };
  return (
    <span
      data-testid={testid || `status-${kind}-${value}`}
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: s.text }} />
      {s.label}
    </span>
  );
}
